import React from 'react';
import { useDarkMode, DM } from '../context/DarkModeContext';
import DentalNewsTicker from './DentalNewsTicker';

/**
 * Unified Header component for all dashboards and reports.
 * 
 * @param {string} label - The text for the badge (e.g., "FACULTY PORTAL")
 * @param {React.ReactNode} children - Right-side action buttons
 * @param {boolean} showNewsTicker - Whether to show the DentalNewsTicker below the header
 */
export default function DashboardHeader({ label, children, showNewsTicker = false }) {
  const { darkMode } = useDarkMode();
  const d = darkMode;

  return (
    <>
      <header style={{ 
        background: DM.headerBg(d), 
        color: "#fff", 
        padding: "0 32px", 
        height: 64, 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between", 
        boxShadow: "0 4px 20px rgba(15,37,87,0.2)", 
        position: "sticky", 
        top: 0, 
        zIndex: 100 
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* Logo + Name - single white box */}
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            background: "#fff", 
            borderRadius: 8, 
            padding: "4px 16px 4px 4px", 
            gap: 8, 
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)" 
          }}>
            <img src="/apdch_logo.png" alt="APDCH" style={{ height: 52, width: 52, objectFit: "contain", flexShrink: 0 }} />
            <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <span style={{ 
                fontWeight: 900, 
                fontSize: 16, 
                color: "#7b1a1a", 
                letterSpacing: 0.3, 
                lineHeight: 1.3, 
                whiteSpace: "nowrap" 
              }}>
                Adhiparasakthi Dental College &amp; Hospital
              </span>
              <span style={{ 
                fontWeight: 700, 
                fontSize: 13, 
                color: "#7b1a1a", 
                letterSpacing: 2, 
                opacity: 0.75 
              }}>
                MELMARUVATHUR
              </span>
            </div>
          </div>

          {/* Divider */}
          <div style={{ width: 1, height: 30, background: "rgba(255,255,255,0.25)" }} />

          {/* Badge Label */}
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <span style={{ 
              background: "rgba(255,255,255,0.18)", 
              border: "1px solid rgba(255,255,255,0.3)", 
              borderRadius: 20, 
              padding: "2px 12px", 
              fontSize: 13, 
              letterSpacing: 1.2, 
              fontWeight: 700, 
              color: "#fff",
              textTransform: "uppercase"
            }}>
              {label}
            </span>
          </div>
        </div>

        {/* Right Side Actions */}
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          {children}
        </div>
      </header>
      
      {showNewsTicker && <DentalNewsTicker />}
    </>
  );
}
